// @flow
export const objectReducer = (setObjectAction: string) => (state: any = {}, action: Object) => {
  switch (action.type) {
    case setObjectAction:
      return {...action.payload};
    default:
      return state;
  }
};